/**
 * ErrorState component
 * Displays an error message with optional retry button
 */

import { Button } from '@/components/ui/button';

export interface ErrorStateProps {
  /** Error title (optional, defaults to "Something went wrong") */
  title?: string;

  /** Error message to display */
  message: string;

  /** Optional retry callback function */
  onRetry?: () => void;
}

/**
 * ErrorState - Displays error with retry button
 */
export function ErrorState({ title, message, onRetry }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {title || 'Something went wrong'}
      </h3>
      <p className="text-sm text-gray-500 text-center mb-4">{message}</p>
      {onRetry && (
        <Button onClick={onRetry} variant="default">
          Try again
        </Button>
      )}
    </div>
  );
}
